<template>
  <div class="dictindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>文件列表</span>
        <el-button class="tz-r tz-create-btn" round @click="jump('/training')"
          >返回</el-button
        >
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="createFile"
          >创建文件</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <!-- <el-row>
        <el-col :span="9">
          <el-input
            placeholder="请输入标题"
            v-model="titleinfo"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="cataSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row> -->
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="fileList" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination> -->
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Editfile
      :state="editState"
      @close="editState = false"
      :row="editUnit"
      @confirm="changeFile"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import { fileList, updateFile, deleteFile, updateStatus } from '@/api/training'
import TzTable from '@/components/tz-table/Index.vue'
import Editfile from './components/Editfile'
export default {
  components: {
    TzTable,
    Editfile
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      titleinfo: '',
      cataId: '',
      editState: false,
      editUnit: {},
      fileList: [],
      columns: [
        {
          field: 'uploadType',
          title: '文件类型'
        },
        // {
        //   field: 'uploadUrl',
        //   title: '上传地址'
        // },
        {
          field: 'uploadName',
          title: '文件名称'
        },
        {
          field: 'remark',
          title: '备注'
        },
        {
          title: '附件',
          type: 'download',
          payload: {
            field: 'uploadUrl'
          }
        },
        {
          title: '状态',
          type: 'switch',
          payload: {
            field: 'deactive',
            change: (row) => this.changeUnitState(row)
          }
        },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('编辑', row)
                // this.editUnit = JSON.parse(JSON.stringify(row))
                let edirArr = JSON.parse(JSON.stringify(row))
                // edirArr['status'] = edirArr['status'] === '启用' ? 1 : 2
                // 上传类型
                edirArr['fileType'] = edirArr['uploadType'] === 'edit' ? 2 : 1
                this.editUnit = edirArr
                console.log('编辑', this.editUnit)
                // 显示弹框
                this.editState = true
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  created() {
    this.setup()
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.getFlieList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getFlieList()
    },
    setup() {
      console.log(this.$route.query)
      this.cataId = this.$route.query.id
    },
    createFile() {
      this.$router.push({
        path: '/training/filecreate',
        query: { id: this.cataId }
      })
    },
    // 列表
    getFlieList() {
      let fileparams = {
        trainId: this.cataId
      }
      fileList(fileparams).then((res) => {
        if (res.code == 200) {
          let flieArr = res.data
          // this.total = res.data.total
          this.fileList = flieArr.map((item) => {
            return {
              id: item.id,
              status: item.status,
              deactive: Number(item.status) === 1 ? true : false,
              uploadType: item.uploadType,
              uploadName: item.uploadName,
              uploadUrl: item.uploadUrl,
              fileSize: item.fileSize,
              // sort: item.sort,
              remark: item.remark
              // startDt: item.startDt,
              // endDt: item.endDt
            }
          })
        }
      })
    },

    // 编辑
    changeFile(infos) {
      console.log(infos, '更新')
      this.$loading({
        text: '文件更新中'
      })
      infos.status = infos.deactive ? 1 : 0
      delete infos.deactive
      let updateparams = {
        ...infos

        // status: infos.deactive ? 1 : 0
      }
      console.log(updateparams)
      updateFile(updateparams).then((res) => {
        console.log(res.data, '更新')
        this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getFlieList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
        this.editState = false
      })
      setTimeout(() => {
        this.$loading().close()
      }, 1000)
    },
    // 删除
    deleteFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteFile(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getFlieList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 状态改变
    changeUnitState(infos) {
      console.log(infos)
      let updateStatusparams = {
        // ...infos,
        id: infos.id,
        status: infos.deactive ? 1 : 0
      }
      console.log(updateStatusparams)

      updateStatus(updateStatusparams).then((res) => {
        console.log(res.data, '更新')
        // this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getFlieList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
      })
    },
    // 模糊查询
    cataSearch() {
      // this.page = 1
      this.getFlieList()
    }
  },
  mounted() {
    this.getFlieList()
  }
}
</script>

<style></style>
